/**
 * View component for /user/login
 *
 * On render cycle this component checks to see if the redirectToReferrer boolean
 * is true (flipped on successful login).  If true, send the user back to the
 * referring page.  If false, show user login form.
 *
 * NOTE: upon reaching this page, user can toggle between /user/login and
 * /user/register without changing the original referring source route.
 */

/**
 * NOTES on the acrp login pages/redirects:
 * 
 * wtf is this monstrosity of a url
 * https://www.avectraacrp.com/eweb/DynamicPage.aspx?Site=ACRP&WebCode=LoginRequired&URL_Success=https%3A%2F%2Facrpnet.org%2Fsso%2Facs%2F%3FuserToken%3D%7Btoken%7D%26returnURL%3Dhttps%253A%252F%252Facrpnet.org
 * 
 *  * https://www.avectraacrp.com/eweb/DynamicPage.aspx
 *    ?Site=ACRP
 *    &WebCode=LoginRequired
 *    &URL_Success=https%3A%2F%2Facrpnet.org%2Fsso%2Facs%2F%3FuserToken%3D%7Btoken%7D%26returnURL%3Dhttps%253A%252F%252Facrpnet.org
 *  
 * 
 * http://localhost:3030/?provider=acrp&authToken={token}
 * http://localhost:3030/?provider=acrp&authToken=%7Btoken%7D
 * 
 * got it working. used https://www.urlencoder.org/ because encodeURI() didnt do anything worthwhile
 * 
 * LOCAL LINK:
 * https://www.avectraacrp.com/eweb/DynamicPage.aspx?Site=ACRP&WebCode=LoginRequired&URL_Success=http%3A%2F%2Flocalhost%3A3030%2F%3Fprovider%3Dacrp%26authToken%3D%7Btoken%7D
 * 
 * STAGING:
 * https://www.avectraacrp.com/eweb/DynamicPage.aspx?Site=ACRP&WebCode=LoginRequired&URL_Success=https%3A%2F%2Fredstone.f-labs.co%2F%3Fprovider%3Dacrp%26authToken%3D%7Btoken%7D
 * 
 * PRODUCTION:
 * https://www.avectraacrp.com/eweb/DynamicPage.aspx?Site=ACRP&WebCode=LoginRequired&URL_Success=https%3A%2F%2Fapp.pro-ficiency.com%2F%3Fprovider%3Dacrp%26authToken%3D%7Btoken%7D
 * 
 */



// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Redirect, withRouter } from 'react-router-dom';

// import actions actions
import * as userActions from '../userActions';
import * as userEventActions from '../../userEvent/userEventActions';

// import form components
import AlertModal from '../../../global/components/modals/AlertModal.js.jsx';
import Base from "../../../global/components/BaseComponent.js.jsx";
// import user components
import UserLayout from '../components/UserLayout.js.jsx';
// import utils
import routeUtils from '../../../global/utils/routeUtils';
// not updating links here because this should be deprecated
class UserThirdPartyLogin extends Base {
  constructor(props) {
    super(props);
    this.state = {
      errorMessage: ''
      , isErrorModalOpen: false
      , redirectToReferrer: false
    }
    this._bind(
      '_errorAction'
      , '_toggleErrorModal'
    );
  }

  componentDidMount() {
    if(this.props.user && this.props.user.username) {
      this.props.history.push('/my-agenda');
    } else {
      const { dispatch, location, match } = this.props;
      const searchObject = routeUtils.objectFromQueryString(location.search);
      // console.log("LOCATION!", location)
      // console.log("SEARCH OBJECT", searchObject)
      // console.log("PROVIDER", match.params.provider)
      const externalLoginPayload = {
        authToken: searchObject.authToken
        , provider: match.params.provider
      }

      dispatch(userActions.sendThirdPartyLogin(externalLoginPayload)).then(action => {
        if(action.success) {
          // console.log('success, do stuff')
          this.props.dispatch(userEventActions.sendCreateUserEvent({
            eventType: "user"
            , eventAction: "external-login"
          }));

          this.setState({redirectToReferrer: true});
          this.props.history.push('/my-agenda');

        } else {
          this.props.dispatch(userEventActions.sendCreateUserEvent({
            eventType: "user"
            , eventAction: "failed-external-login"
            , description: match.params.provider + ": " + action.error
          }));
          this.setState({errorMessage: action.error});
          this._toggleErrorModal();
        }
      })

    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState(nextProps);
    if(nextProps.status === "error") {
      alert(nextProps.error.message);
    }
  }

  _toggleErrorModal() {
    this.setState({isErrorModalOpen: !this.state.isErrorModalOpen});
  }

  _errorAction() {
    // so in the event of an error on this page, there isn't a whole lot we can do
    // only real choice I can think of is to redirect them somewhere? but home page is kind of useless unless you can log in first
    this.props.history.push('/');
  }

  render() {
    // console.log("RENDERING third party login");
    const { from } = this.props.location.state || { from: { pathname: '/' } }
    const { redirectToReferrer, user } = this.state;

    if(redirectToReferrer) {
      return (
        <Redirect to={from} />
      )
    } else {
      return  (
        <UserLayout>
          <div className="yt-container">
            <div className="yt-row center-horiz">
              <h1>loading Single Sign On...</h1>
              <br/>
              <br/>
              <svg width="600" height="600">
                <g transform="translate(50,50)"><circle cx="0" cy="0" r="8.333333333333334" fill="none" stroke="#053380" strokeWidth="6.5" strokeDasharray="26.179938779914945 26.179938779914945">
                <animateTransform attributeName="transform" type="rotate" values="0 0 0;-360 0 0" times="0;1" dur="2.0833333333333335s" calcMode="spline" keySplines="0.2 0 0.8 1" begin="0" repeatCount="indefinite"></animateTransform>
                </circle><circle cx="0" cy="0" r="16.666666666666668" fill="none" stroke="#fc6220" strokeWidth="6.5" strokeDasharray="52.35987755982989 52.35987755982989">
                <animateTransform attributeName="transform" type="rotate" values="0 0 0;360 0 0" times="0;1" dur="2.0833333333333335s" calcMode="spline" keySplines="0.2 0 0.8 1" begin="-0.4166666666666667" repeatCount="indefinite"></animateTransform>
                </circle><circle cx="0" cy="0" r="25" fill="none" stroke="#0e0e0e" strokeWidth="6.5" strokeDasharray="78.53981633974483 78.53981633974483">
                <animateTransform attributeName="transform" type="rotate" values="0 0 0;-360 0 0" times="0;1" dur="2.0833333333333335s" calcMode="spline" keySplines="0.2 0 0.8 1" begin="-0.8333333333333334" repeatCount="indefinite"></animateTransform>
                </circle><circle cx="0" cy="0" r="33.333333333333336" fill="none" stroke="#053380" strokeWidth="6.5" strokeDasharray="104.71975511965978 104.71975511965978">
                <animateTransform attributeName="transform" type="rotate" values="0 0 0;360 0 0" times="0;1" dur="2.0833333333333335s" calcMode="spline" keySplines="0.2 0 0.8 1" begin="-1.25" repeatCount="indefinite"></animateTransform>
                </circle><circle cx="0" cy="0" r="41.666666666666664" fill="none" stroke="#fc6220" strokeWidth="6.5" strokeDasharray="130.89969389957471 130.89969389957471">
                <animateTransform attributeName="transform" type="rotate" values="0 0 0;-360 0 0" times="0;1" dur="2.0833333333333335s" calcMode="spline" keySplines="0.2 0 0.8 1" begin="-1.6666666666666667" repeatCount="indefinite"></animateTransform>
                </circle></g>
              </svg>
            </div>
            <AlertModal
              alertMessage={this.state.errorMessage}
              alertTitle="Error with third party sign in"
              closeAction={this._errorAction}
              confirmAction={this._errorAction}
              confirmText="Go back to home"
              declineText=""
              declineAction={this._errorAction}
              isOpen={this.state.isErrorModalOpen}
              type="danger"
            />
          </div>
        </UserLayout>
      )
    }
  }
}

UserThirdPartyLogin.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  return {
    user: store.user.loggedIn.user
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(UserThirdPartyLogin)
);



// WEBPACK FOOTER //
// modules/user/views/UserThirdPartyLogin.js.jsx